import React from 'react';
import WorkforceDetailsFieldComponent from "../../../../components/WorkForce/WorkforceDetailsFieldComponent";
import {Input, Select} from "antd";
import {useDropdowns} from "../../../../hooks/useDropdowns";
import TextArea from "antd/es/input/TextArea";
import {useSelector} from "react-redux";


const AlarmCaseDetails = () => {
    const {state} = useDropdowns();
    const { workforceCaseDetails } = useSelector((state) => state.Workforce);

    return (
        <div className="grid grid-cols-2 gap-5">
            <WorkforceDetailsFieldComponent fieldName={"Case ID"} fieldId={"caseIdStr"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"caseIdStr"}
                    value={workforceCaseDetails?.caseIdStr} //
                    onChange={(val) => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Alarm Type"}
                fieldId={"alarmType"}
            >
                <Select
                    disabled={true}
                    placeholder={""}
                    value={workforceCaseDetails?.alarmType?.name} //
                    onChange={(val) => {
                    }}
                    options={state?.alarmTypesDropDown.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    })}
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent
                fieldName={"Creation Date"}
                fieldId={"creationDate"}
            >
                <Input
                    disabled={true}
                    id={"creationDate"}
                    value={workforceCaseDetails?.createdAt} //
                    onChange={(val) => {
                    }}
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent
                fieldName={"Meter ID"}
                fieldId={"meterId"}
            >
                <Select
                    disabled={true}
                    showSearch
                    placeholder={""}
                    value={workforceCaseDetails?.device?.meterSN} //
                    onChange={(val) => {
                    }}
                    options={state?.devices.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    })}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent
                fieldName={"Created By"}
                fieldId={"createdBy"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"createdBy"}
                    value={workforceCaseDetails?.createdBy} //
                    onChange={(val) => {
                    }}
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent
                fieldName={"Installation Date"}
                fieldId={"installationDate"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    value={workforceCaseDetails?.device?.installationDate}
                    id={"installationDate"}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Case Type"}
                fieldId={"caseType"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"caseType"}
                    value={workforceCaseDetails?.caseType?.name} //
                    onChange={(val) => {
                    }}
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent fieldName={"Region"} fieldId={"region"}>
                <Input

                    disabled={true}
                    placeholder=""
                    id={"region"}
                    value={workforceCaseDetails?.region} //
                    onChange={(val) => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Assign To"}
                fieldId={"assignTo"}
            >
                <Select
                    disabled={true}
                    placeholder={""}
                    value={workforceCaseDetails?.technicianGroup?.name}
                    id={"technicianGroupId"}
                    onChange={() => {
                    }}
                    options={state?.technicianGroupsDropdown?.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    }) ?? []}
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Consumer Name"}
                fieldId={"consumerName"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"consumerName"}
                    value={workforceCaseDetails?.device?.consumerName}
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent
                fieldName={"Case Status"}
                fieldId={"caseStatus"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"consumerName"}
                    value={workforceCaseDetails?.status?.name}
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent fieldName={"Address"} fieldId={"address"} className={"col-start-2"}>
                <TextArea
                    disabled={true}
                    placeholder=""
                    id={"address"}
                    value={workforceCaseDetails?.device?.address}
                />
            </WorkforceDetailsFieldComponent>


        </div>
    );

}

export default AlarmCaseDetails;